module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ClaimFlow"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('p', {
    staticClass: "title2"
  }, [_vm._v("商户通过WiFi万能钥匙分享WiFi后，因黑客篡改WiFi密码、劫持商户收银、盗刷商户账户内资金等恶意行为，导致商户在银行账户内的资产，及商户在合法运营的第三方支付机构所设本商户实名账户中的资产遭受损失，应立即采取以下措施：")]), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_c('span', {
    staticClass: "circle"
  }), _vm._v("1.证据保全")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("商户在使用WiFi万能钥匙分享热点后，发现账户资金遭受损失的，应立即采取相关证据保全措施，不应自行刷机、清理交易设备缓存、删除WiFi万能钥匙客户端、历史短信或历史访问网址记录，或自行删除交易过程中与交易对方的聊天记录及所下载的软件，以免导致相关证据无法保全；")]), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_c('span', {
    staticClass: "circle"
  }), _vm._v("2.报案")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("商户在使用WiFi万能钥匙分享热点后，发现账户资金遭受损失的，应立即拨打保险公司电话进行报案，并应于10个自然日内前往具有管辖权的公安机关进行报案，并取得案件受理通知书等相关证明材料；")]), _vm._v(" "), _c('p', {
    staticClass: "text highlight"
  }, [_vm._v("众安保险客服电话:400-999-9595")]), _vm._v(" "), _c('p', {
    staticClass: "text highlight"
  }, [_vm._v("(7×24小时统一客服热线)")]), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_c('span', {
    staticClass: "circle"
  }), _vm._v("3.准备索赔资料")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("商户应自账户资金遭受经济损失之日起15个自然日内根据WiFi万能钥匙客户端索赔界面的提示准备索赔资料，并听从工作人员的操作指导，积极配合工作人员的工作，并配合提供相关损失证明文件，以便有效追查被盗情况并保全证据；")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("若保险公司或WiFi万能钥匙的工作人员联系用户时，首次尝试联系商户起72小时内仍无法与商户取得联系的，或商户不履行本协议约定的配合义务的，将视商户自动放弃索赔。")]), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_c('span', {
    staticClass: "circle"
  }), _vm._v("4.提交索赔资料")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("商户应根据保险公司工作人员的指示提交索赔资料，并确保其所提交的资料的真实性，否则，本公司及保险公司有权拒绝受理或赔付商户的索赔申请；商户知悉并了解，该等资料中的相关信息包括但不限于商户身份证号码、银行卡号、手机号码、详细住址等个人信息，商户在此同意并授权本公司及保险公司为实现本协议项下的索赔目的对商户的该等个人信息予以采集和使用；")]), _vm._v(" "), _c('p', [_vm._v("商户应通过线下快递方式递交如下索赔资料（不接受快递到付）：")]), _vm._v(" "), _c('p', {
    staticClass: "text highlight"
  }, [_vm._v("\n        收件人：WiFi万能钥匙商户安全理赔项目组"), _c('br'), _vm._v("\n        快递联系电话：400-035-8000"), _c('br'), _vm._v("\n        寄送地址：上海市浦东新区张衡路666弄1号楼7楼\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_c('span', {
    staticClass: "circle"
  }), _vm._v("5.理赔结果")]), _vm._v(" "), _c('p', {
    staticClass: "text last"
  }, [_vm._v("保险公司根据商户提交的材料将认定最终理赔结果，如最终确认属于理赔责任范围内的情形，由保险公司向商户指定的个人收款账户支付赔款，最终理赔额在人民币3000元（含3000元）以下的案件由保险公司在确认最终理赔结果后的5个工作日之内支付赔款；最终理赔额在人民币3000元以上的案件由保险公司在确认最终理赔结果后的10个工作日之内支付赔款。")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08407e18"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/claimFlow.vue
// module id = 809
// module chunks = 1